import { useSearchParams } from "react-router-dom";
import { useStaff } from "@/lib/staff";
import { PageHead } from "@/components/staff/ui";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UsageTab } from "@/components/staff/UsageTab";
import { BillingTab } from "@/components/staff/BillingTab";
import { DiscountCodes } from "@/components/staff/DiscountCodes";
import { DailyLimitsPanel } from "@/components/DailyLimitsPanel";
import { RatesTab } from "@/components/staff/RatesTab";

const TABS = [
  { id: "usage", label: "AI usage", perm: "billing.view", el: () => <UsageTab /> },
  { id: "billing", label: "Billing", perm: "billing.view", el: () => <BillingTab /> },
  { id: "codes", label: "Discount codes", perm: "discounts.manage", el: () => <DiscountCodes /> },
  { id: "limits", label: "Plan limits", perm: "billing.view", el: (can) => <DailyLimitsPanel readOnly={!can("plans.config")} /> },
  { id: "rates", label: "AI cost rates", perm: "billing.view", el: () => <RatesTab /> },
];

export default function UsageBillingPage() {
  const { can } = useStaff();
  const [sp, setSp] = useSearchParams();
  const tabs = TABS.filter((t) => can(t.perm));
  const tab = tabs.some((t) => t.id === sp.get("tab")) ? sp.get("tab") : tabs[0]?.id;
  return (
    <div data-testid="staff-usage-billing">
      <PageHead title="Usage & Billing" sub="Estimated AI cost is our own estimate. Amounts billed by Stripe are shown separately and never mixed with estimates." />
      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v }, { replace: true })}>
        <TabsList className="bg-[#0C1322] border border-[#1B2740] rounded-full p-1 h-auto flex-wrap mb-5" data-testid="usage-billing-tabs">
          {tabs.map((t) => (
            <TabsTrigger key={t.id} value={t.id} className="rounded-full px-4 py-1.5 text-sm data-[state=active]:bg-sky-400 data-[state=active]:text-white" data-testid={`tab-${t.id}`}>{t.label}</TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((t) => <TabsContent key={t.id} value={t.id}>{tab === t.id && t.el(can)}</TabsContent>)}
      </Tabs>
    </div>
  );
}
